import { Component, OnInit } from '@angular/core';
import { ApiService } from '../app.service';

@Component({
	selector: 'app-pizzas',
	templateUrl: './pizzas.component.html',
	styleUrls: ['./pizzas.component.scss']
})
export class PizzasComponent implements OnInit {

	pizzas: any;
	filteredPizzas: any;
	ingredients: any;

	filterBtn = 1;
	pizzaMonth: any;
	selectedImg: string;
	selectedIng: any;
	isFiltering = false;
	html: any;

	constructor(public api: ApiService) { }

	ngOnInit() {
		this.api.get('function=getAll').then((res: any) => {
			this.ingredients = res.ingredients;
			for (const pizza of res.products) {
				const pizzaIngIds = this.parseIngredientIds(pizza.ingredients);
				let str = '';
				for (const ing of this.ingredients) {
					if (pizzaIngIds.indexOf(Number(ing.value)) > -1) {
						str += ing.label + ', ';
					}
				}
				pizza.ingFormated = str.slice(0, -2);
				if (str.indexOf('Sauce Tomate') > -1) {
					pizza.cat = 'Base tomate';
				} else if (str.indexOf('Crème fraîche') > -1) {
					pizza.cat = 'Base crème';
				} else if (str.toLowerCase().indexOf('chocolat') > -1) {
					pizza.cat = 'Dessert';
				} else {
					pizza.cat = 'Base tomate';
				}
				if (pizza.name_product.indexOf('Pizza du Moment') > -1 && pizza.active == '1') {
					this.pizzaMonth = pizza;
				}
			}
			this.pizzas = this.filteredPizzas = res.products.filter(item => {
				return item.active == '1' && item.name_product.indexOf('Moment') === -1;
			});
		});
	}

	/** API mixes number IDs ([33,28]) and string IDs (["1","34"]). Normalize to numbers. */
	private parseIngredientIds(raw: string): number[] {
		return JSON.parse(raw).map((id: string | number) => Number(id));
	}

	setFilter(str: string, type: string, btn: number) {
		this.filterBtn = btn;
		this.filter(str, type);
	}

	filter(str, type) {
		this.isFiltering = true;
		setTimeout(() => {
			if (type === 'cat') {
				this.selectedIng = [];
				this.filteredPizzas = this.pizzas.filter(item => {
					return item.cat === str || str === '';
				});
			}
			if (type === 'ing') {
				this.selectedIng = [];
				this.filteredPizzas = this.pizzas.filter(item => {
					return item.ingFormated.indexOf(str) > -1;
				});
			}
			if (type === 'multiple') {
				this.filterBtn = 0;
				this.filteredPizzas = this.pizzas.filter(item => {
					const ings = this.parseIngredientIds(item.ingredients);
					for (const ing of this.selectedIng) {
						if (!ings.includes(Number(ing))) {
							return false;
						}
					}
					return true;
				});
			}
			this.isFiltering = false;
		}, 180);
	}
}
